var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "separable" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-row",
            [
              _vm.notificacaoWhatsApp
                ? _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "containerBotaoWhatsapp" }, [
                      _c(
                        "div",
                        {
                          style: { "margin-right": _vm.isAmapa ? "2%" : "35%" }
                        },
                        [
                          _c("p", [_vm._v("Notificação via whatsapp")]),
                          _vm.processo
                            ? _c("el-switch", {
                                attrs: { "active-color": "#13ce66" },
                                on: {
                                  change: function($event) {
                                    return _vm.ativarDesativarNotificaWhatsApp(
                                      _vm.processo
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.processo.notificarWhatsApp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.processo,
                                      "notificarWhatsApp",
                                      $$v
                                    )
                                  },
                                  expression: "processo.notificarWhatsApp"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticClass: "cardListagem card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v("Listagem de mensagens")
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "div",
                        { staticClass: "table-pointer" },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    data: _vm.conversa.content,
                                    stripe: "stripe",
                                    "default-sort": {
                                      prop: "id",
                                      order: "descending"
                                    }
                                  },
                                  on: { "row-click": _vm.goTo }
                                },
                                [
                                  _c("template", { slot: "empty" }, [
                                    _vm._v("Não há mensagens.")
                                  ]),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "status",
                                      width: "90"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm.checkVizualizacao(scope.row)
                                              ? _c("div", [
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-envelope",
                                                      staticStyle: {
                                                        "font-size": "20px"
                                                      }
                                                    })
                                                  ])
                                                ])
                                              : _c("div", [
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fal fa-envelope-open",
                                                      staticStyle: {
                                                        "font-size": "20px"
                                                      }
                                                    })
                                                  ])
                                                ])
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "row",
                                      label: "Data e hora",
                                      width: "250",
                                      formatter: _vm.setData
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "assunto",
                                      label: "Assunto",
                                      "min-width": "430"
                                    }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._t("default")
                    ],
                    2
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f4f811a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f4f811a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppListaConversas.vue
// module id = null
// module chunks = 